import { Building2, TrendingUp, DollarSign } from 'lucide-react';
import { Card, CardContent } from '@/components/ui/card';
import { formatCurrencyCompact } from '@/utils/formatters';

interface FundStatistics {
  total_funds: number;
  total_commitments: number;
  active_funds: number;
  status_breakdown: Record<string, number>;
}

interface FundsSummaryProps {
  statistics: FundStatistics | null | undefined;
}

export function FundsSummary({ statistics }: FundsSummaryProps) {
  if (!statistics) {
    return null;
  }

  return (
    <div className="grid grid-cols-1 md:grid-cols-4 gap-4 mt-8">
      <Card>
        <CardContent className="p-6">
          <div className="flex items-center">
            <div className="p-2 bg-muted rounded-lg">
              <Building2 className="h-5 w-5 text-foreground" />
            </div>
            <div className="ml-4">
              <p className="text-sm font-medium text-muted-foreground">
                Total Funds
              </p>
              <p className="text-2xl font-bold text-foreground">
                {statistics?.total_funds || 0}
              </p>
            </div>
          </div>
        </CardContent>
      </Card>

      <Card>
        <CardContent className="p-6">
          <div className="flex items-center">
            <div className="p-2 bg-green-100 dark:bg-green-900/30 rounded-lg">
              <DollarSign className="h-5 w-5 text-green-600 dark:text-green-400" />
            </div>
            <div className="ml-4">
              <p className="text-sm font-medium text-muted-foreground">
                Total Commitments
              </p>
              <p className="text-2xl font-bold text-foreground">
                {formatCurrencyCompact(statistics?.total_commitments || 0)}
              </p>
            </div>
          </div>
        </CardContent>
      </Card>

      <Card>
        <CardContent className="p-6">
          <div className="flex items-center">
            <div className="p-2 bg-purple-100 dark:bg-purple-900/30 rounded-lg">
              <TrendingUp className="h-5 w-5 text-purple-600 dark:text-purple-400" />
            </div>
            <div className="ml-4">
              <p className="text-sm font-medium text-muted-foreground">
                Active Funds
              </p>
              <p className="text-2xl font-bold text-foreground">
                {statistics?.active_funds || 0}
              </p>
            </div>
          </div>
        </CardContent>
      </Card>

      <Card>
        <CardContent className="p-6">
          <div className="flex items-center">
            <div className="p-2 bg-amber-100 dark:bg-amber-900/30 rounded-lg">
              <Building2 className="h-5 w-5 text-amber-600 dark:text-amber-400" />
            </div>
            <div className="ml-4">
              <p className="text-sm font-medium text-muted-foreground">
                Setup Phase
              </p>
              <p className="text-2xl font-bold text-foreground">
                {statistics?.status_breakdown?.setup || 0}
              </p>
            </div>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
